import vSelect from "vue-select";
import { TippyComponent } from "vue-tippy";

import Vue from "vue";

// eslint-disable-next-line vue/multi-word-component-names
Vue.component("Tippy", TippyComponent);
Vue.component("VSelect", vSelect);
